import React, { useState, useEffect } from "react";
import Logo from "./../images/vendora.png";
import { Link} from "react-router-dom";
import "./Header.css"; // Import your CSS file

const Header = () => {
  const [active, setActive] = useState(false);

  const toggleNavbar = () => {
    setActive(!active);
  };

  const removeNavbar = () => {
    setActive(false); // Close the mobile menu
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setActive(false); 
      } else {
        setActive(false); 
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const scrollToSectionWithOffset = (sectionId, yOffset) => {
    const section = document.getElementById(sectionId);
    if (section) {
      const elementPosition = section.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({
        top: elementPosition - yOffset,
        behavior: "smooth",
      });
      setActive(false); // Close the mobile menu
    }
  };
  const scrollToWhySection = () => {
    scrollToSectionWithOffset("why", 100);
  };
  const scrollToFeaturesSection = () => {
    scrollToSectionWithOffset("features", 150); 
  };
  
  const scrollToBenefitsSection = () => {
    scrollToSectionWithOffset("benefits", 150); 
  };
  
  const scrollToIndustriesSection = () => {
    scrollToSectionWithOffset("industries", 100);
  };
  const scrollToQuotesSection = () => {
    scrollToSectionWithOffset("quotes", 100);
  };
  
  // const scrollToTop = () => {
  //   window.scrollTo({
  //     top: 0,
  //     behavior: "smooth",
  //   });
  // };
  
  const navbarClassName = active ? "bottom-header showNavbar" : "bottom-header";

  return (
    <div className={`header ${active ? "sticky" : ""}`} id="home">
      <div className="container">
        <div className="header-section">
          <div className="logo">
            <Link to="https://www.vendorascmsoftware.com/" target="_blank" >
              <img src={Logo} alt="logo" />
            </Link>
          </div>
          <div className="menu-section">
            <div className="top-header">
              <ul>
                <li>
                  <Link to="mailto:info@vendorascmsoftware.com">
                    <i className="fa-solid fa-envelope"></i>{" "}
                    info@vendorascmsoftware.com
                  </Link>
                </li>
                <li>
                  <Link to="tel:+91-9361663950">
                    <i className="fa-solid fa-phone"></i> +91-9361663950
                  </Link>
                </li>
              </ul>
            </div>
            <div className={navbarClassName}>
              <div className="mobile-toggle" onClick={toggleNavbar}>
                <i className="fa-solid fa-bars"></i>
              </div>
              <ul>
                <li onClick={removeNavbar}>
                  <Link to="/#why" onClick={scrollToWhySection}>
                    Why Vendora
                  </Link>
                </li>
                <li onClick={removeNavbar}>
                  <Link to="/#features" onClick={scrollToFeaturesSection}>
                    Product Features
                  </Link>
                </li>
                <li onClick={removeNavbar}>
                  <Link to="/#benefits" onClick={scrollToBenefitsSection}>
                    Key Benefits
                  </Link>
                </li>
                <li onClick={removeNavbar}>
                  <Link to="/#industries" onClick={scrollToIndustriesSection}>
                    Industries
                  </Link>
                </li>
              </ul>
              <Link to="/#quotes" onClick={scrollToQuotesSection} className="top-button">
                Get Quick Quote
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
